import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const PlanCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 12rem;
`

export const PlanCode = styled.span`
  font-family: 'Courier New', monospace;
  font-size: 0.75rem;
  color: ${tokens.text.secondary};
`

export const TargetCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 10rem;
`

export const ProgressTrack = styled.div`
  width: 100%;
  height: 4px;
  background: ${tokens.border.hairline};
  border-radius: 2px;
  overflow: hidden;
`

export const ProgressFill = styled.div`
  height: 100%;
  background: ${tokens.accent.base};
  border-radius: 2px;
`

interface OwnerBadgeProps {
  $tokenKey: string
}

export const OwnerInitialsBadge = styled.div<OwnerBadgeProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.7rem;
  color: ${tokens.text.primary};
  background: ${(p) => {
    const themeRecord = p.theme as unknown as Record<string, string>
    return themeRecord[p.$tokenKey] ?? tokens.text.secondary
  }};
`

export const SandboxPreview = styled.div`

  margin-top: 1rem;
  width: 100%;
  padding: 1rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: 0.5rem;

`

export const AddPhaseSection = styled.div`
  margin-top: 1rem;
  border: 1px dashed ${tokens.accent.base};
  border-radius: 0.5rem;
  padding: 1rem;

`

export const NotYetAdded = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border: 1px dashed ${tokens.border.hairline};
  border-radius: 0.5rem;
  padding: 1rem;
`